import { useState } from 'react';
import { ClearIndicatorProps } from 'react-select';
import styled from 'styled-components';

import { IconX } from '../../../common/icons/cdl/X';
import { theme } from '../../../common/ui/theme';

const StyledClearIndicator = styled.div<{ $isHovered: boolean }>`
    height: ${theme.space[24]};
    cursor: pointer;
    padding: ${theme.space[2]};
    margin-right: ${theme.space[4]};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => (props.$isHovered ? theme.colors.foreground.default : theme.colors.foreground.subtle)};
    transition: color 75ms ease-in-out;
`;

interface CustomClearIndicatorProps extends ClearIndicatorProps {}

export const CustomClearIndicator = (props: CustomClearIndicatorProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <StyledClearIndicator
            {...props.innerProps}
            $isHovered={isHovered}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <IconX width={16} height={16} />
        </StyledClearIndicator>
    );
};
